import { interactionsTypeActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_INTERACTIONTYPE,
  FETCHING_INTERACTIONTYPE,
  FETCH_INTERACTIONTYPE_ERROR,
  FETCH_INTERACTIONSTYPE,
  FETCHING_INTERACTIONSTYPE,
  FETCH_INTERACTIONSTYPE_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_INTERACTIONTYPE,
  DELETE_INTERACTIONTYPE,
  ADD_INTERACTIONTYPE,
  EDIT_INTERACTIONTYPE,
  FORM_TOUCHED,
  NEW_FORM_INTERACTIONTYPE,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  INTERACTIONTYPE_FORM_ERROR,
  RESET_STATE,
  FETCHING_LOGS,
  FETCH_LOGS,
  FETCH_LOGS_ERROR,
  OPEN_LOGS_MODAL,
  CLOSE_LOGS_MODAL
} = interactionsTypeActions

const initialState = {
  loadingInteractionType: false,
  loadingInteractionsType: false,
  fetchInteractionTypeError: false,
  fetchInteractionsTypeError: false,
  interactionsType: [],
  order: {
    column: 'nome',
    direction: 1
  },
  interactionType: {
    nome: '',
    efeito: '',
    mecanismoProvavel: '',
    tempoInicio: '',
    sugestaoManejo: ''
  },
  interactionsTypePagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  interactionTypeFormErrors: {},
  interactionTypeFormTouched: false,
  modalOpen: false,
  logs: [],
  loadingLogs: false,
  fetchLogsError: false,
  openLogsModal: false
}

const interactionTypeSchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    },
    efeito: {
      required: true
    },
    gravidade_id: {
      required: true
    },
    probabilidade_id: {
      required: true
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    },
    efeito: {
      required: true
    },
    gravidade_id: {
      required: true
    },
    probabilidade_id: {
      required: true
    }
  }
}

const InteractionTypeValidate = new ValidateFormObject(interactionTypeSchema)

const interactionsType = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_INTERACTIONTYPE:
      formSchemaType = action.interactionType._id ? 'edit' : 'add'
      return {
        ...state,
        interactionType: action.interactionType,
        interactionTypeFormErrors: InteractionTypeValidate.validate({
          formObject: action.interactionType,
          formSchemaType
        })
      }
    case INTERACTIONTYPE_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.interactionType._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        interactionTypeFormErrors: InteractionTypeValidate.validate({
          formObject: state.interactionType,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_INTERACTIONTYPE:
      return {
        ...state,
        interactionType: { ...initialState.interactionType },
        interactionTypeFormErrors: InteractionTypeValidate.validate({}),
        interactionTypeFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        interactionTypeFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_INTERACTIONTYPE:
      formSchemaType = (action.interactionType || {})._id ? 'edit' : 'add'
      return {
        ...state,
        interactionType: action.interactionType,
        loadingInteractionType: false,
        fetchInteractionTypeError: false,
        interactionTypeFormTouched: false,
        interactionTypeFormErrors: InteractionTypeValidate.validate({
          formObject: action.interactionType,
          formSchemaType
        })
      }
    case FETCHING_INTERACTIONTYPE:
      return {
        ...state,
        loadingInteractionType: true,
        fetchInteractionTypeError: false
      }
    case DELETE_INTERACTIONTYPE:
      return {
        ...state,
        loadingInteractionsType: false,
        fetchInteractionTypeError: false,
        interactionsType: state.interactionsType.map(interactionType => {
          if (interactionType._id === (action.interactionType || {})._id) {
            return action.interactionType
          }
          return interactionType
        })
      }
    case FETCH_INTERACTIONTYPE_ERROR:
      return {
        ...state,
        loadingInteractionsType: false,
        interactionType: { ...initialState.interactionType },
        fetchInteractionTypeError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        interactionsTypePagination: {
          ...state.interactionsTypePagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        interactionsTypePagination: {
          ...state.interactionsTypePagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_INTERACTIONSTYPE:
      return {
        ...state,
        loadingInteractionsType: false,
        interactionsType: action.interactionsType,
        fetchInteractionsTypeError: false,
        order: action.order,
        interactionsTypePagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_INTERACTIONTYPE:
      return {
        ...state,
        interactionsType: state.interactionsType.map(interactionType => {
          if (interactionType._id === action.interactionType._id) {
            return action.interactionType
          }
          return interactionType
        }),
        loadingInteractionsType: false,
        fetchInteractionTypeError: false,
        loadingInteractionType: false,
        fetchInteractionsTypeError: false
      }
    case FETCHING_INTERACTIONSTYPE:
      return {
        ...state,
        loadingInteractionsType: true,
        fetchInteractionsTypeError: false
      }
    case FETCH_INTERACTIONSTYPE_ERROR:
      return {
        ...state,
        loadingInteractionsType: false,
        fetchInteractionsTypeError: action.error,
        loadingInteractionType: false
      }
    case ADD_INTERACTIONTYPE:
      return {
        ...state,
        loadingInteractionsType: false,
        fetchInteractionsTypeError: false,
        loadingInteractionType: false,
        interactionsType: [...state.interactionsType, action.interactionType]
      }
    case FETCHING_LOGS:
      return {
        ...state,
        loadingLogs: true,
        fetchLogsError: false
      }
    case OPEN_LOGS_MODAL:
      return {
        ...state,
        openLogsModal: true
      }
    case CLOSE_LOGS_MODAL:
      return {
        ...state,
        openLogsModal: false
      }
    case FETCH_LOGS:
      return {
        ...state,
        fetchLogsError: false,
        logs: action.logs,
        loadingLogs: false
      }
    case FETCH_LOGS_ERROR:
      return {
        ...state,
        loadingLogs: false,
        fetchLogsError: action.error
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default interactionsType



// WEBPACK FOOTER //
// ./src/reducers/interactionsType.js